export default "__VITE_ASSET__Bxq8UK3V__"